const ATKOMST_BASIC_PERMISSION = "fixa.basic" as const;
export const ATKOMST_TEAMS_EDITOR_PERMISSION = "fixa.teams-editor" as const;

type AtkomstPermission =
  | typeof ATKOMST_BASIC_PERMISSION
  | typeof ATKOMST_TEAMS_EDITOR_PERMISSION;
export type AtkomstPermissions = AtkomstPermission[];
